<template>
  <div class="progress-bar">
    <span class="progress" v-bind:style="progressPercentage"></span>
  </div>
</template>

<script>
export default {
  props: {
    progress: 0
  },
  computed: {
    progressPercentage() {
      return  {width: + this.progress + '%'};
    }
  }
}
</script>

<style lang="scss" scoped>
@import 'progressBar';
</style>
